export const PLACEHOLDER_URL =
  'https://static.shop-apotheke.com/media/content/placeholder.png'
